<template>
  <ReportMetricCalloutStrip
    class="sla-mgmt-metrics"
    :cards="cards"
    :groupTitles="['SLA E-commerce', 'SLA LTM']"
    :suffix="suffix"
  >
    <template #cardSub="{ card }">
      (<b>{{ formatCount(card.outOfSla) }}</b> units of
      <b>{{ formatCount(card.total) }}</b> are out of SLA)
    </template>
  </ReportMetricCalloutStrip>
</template>

<script>
import ReportMetricCalloutStrip from '@/components/Reports/ReportMetricCalloutStrip.vue';

export default {
  name: 'SlaMetrics',
  components: { ReportMetricCalloutStrip },
  props: {
    callouts: { type: Object, required: true },
    metric: { type: String, required: true },
  },
  computed: {
    suffix() {
      return this.metric === '% in SLA' ? '%' : '';
    },
    cards() {
      const c = this.callouts || {};
      return [
        {
          key: 'ecom-week',
          value: c.ecomWeek,
          label: 'in SLA this Week to Date',
          outOfSla: c.ecomWeekOut,
          total: c.ecomWeekTotal,
        },
        {
          key: 'ecom-month',
          value: c.ecomMonth,
          label: 'in SLA this Month to Date',
          outOfSla: c.ecomMonthOut,
          total: c.ecomMonthTotal,
        },
        {
          key: 'ltm-week',
          value: c.ltmWeek,
          label: 'in SLA this Week to Date',
          outOfSla: c.ltmWeekOut,
          total: c.ltmWeekTotal,
        },
        {
          key: 'ltm-month',
          value: c.ltmMonth,
          label: 'in SLA this Month to Date',
          outOfSla: c.ltmMonthOut,
          total: c.ltmMonthTotal,
        },
      ];
    },
  },
  methods: {
    formatCount(n) {
      return Number(n || 0).toLocaleString('en-US');
    },
  },
};
</script>
